module.exports = __webpack_public_path__ + "static/media/monitor-open.5474ff2b.svg";